<template>
  <div class="root-box">
    <div class="query-container">
      <el-form size="small" :inline="true">
        <el-form-item label="地址类型：" prop="type">
          <el-select v-model="param.type" placeholder="请选择" style="width: 100%" @change="query">
            <el-option v-for="item in typeOpts" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="区域：" prop="pathId">
          <el-select v-model="param.areaId" placeholder="请选择" style="width: 100%" @change="query">
            <el-option v-for="item in enableAreaOpts" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button style="width: 100px; margin-right: 20px" type="primary" @click="query">查询</el-button>
        </el-form-item>

        <el-form-item label="地址搜索">
          <input id="tipinput" type="text" />
        </el-form-item>

        <el-form-item label>
          <el-button type="success" icon="el-icon-document-copy" @click="add">加入常用列表</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="up_price_map">
      <div id="up_price_map"></div>

      <div class="box">
        <el-table ref="dataTable" :data="sortedList" stripe max-height="600" @row-click="rowClick"
          :row-class-name="tableRowClassName" @sort-change="handleSortChange">
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column prop="name" label="区域名称" width="180" sortable="custom"></el-table-column>
          <el-table-column prop="keyName" label="关键字"></el-table-column>

          <el-table-column v-if="param.type === 3" prop="subType" label="子区域类型">
            <template slot-scope="scope">
              <span>{{ scope.row.subType | enumTransfer(stationOpts) }}</span>
            </template>
          </el-table-column>

          <el-table-column v-if="param.type === 3" prop="enterReserveTime" label="进站预留" width="110">
            <template slot-scope="scope">
              <span>{{ formatReserve(scope.row.enterReserveTime, 60) }}</span>
            </template>
          </el-table-column>

          <el-table-column v-if="param.type === 3" prop="exitReserveTime" label="出站预留" width="110">
            <template slot-scope="scope">
              <span>{{ formatReserve(scope.row.exitReserveTime, 20) }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="sortIndex" label="排序序号" width="80"></el-table-column>

          <el-table-column prop="disabled" label="状态" width="90" sortable="custom">
            <template slot-scope="scope">
              <span>{{ scope.row.disabled ? "已禁用" : "启用" }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="pickOrSend" label="生效范围" width="120">
            <template slot-scope="scope">
              <span>{{ scope.row.pickOrSend | enumTransfer(pickOrSendOpts) }}</span>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click.stop="openDiag(scope.row)">修改</el-button>
              <el-button type="text" size="small" @click.stop="toggleDisabled(scope.row)">
                {{ isRowDisabled(scope.row) ? "启用" : "禁用" }}
              </el-button>
              <el-button type="text" size="small" @click.stop="syncPosition(scope.$index)">同步位置</el-button>
              <el-button type="text" size="small" @click.stop="del(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <el-dialog :visible.sync="visible" width="500px" max-height="600" title="修改" :close-on-click-modal="false">
      <el-form ref="form" :model="form" label-width="120px" :size="size" :rules="rules">
        <el-form-item label="名称：" prop="name">
          <el-input v-model="form.name" style="width: 100%"></el-input>
        </el-form-item>

        <el-form-item v-if="param.type === 3" label="车站类型" prop="subType">
          <el-select v-model="form.subType" style="width: 100%">
            <el-option v-for="item in stationOpts" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item v-if="param.type === 3" label="进站预留：" prop="enterReserveTime">
          <el-input-number v-model="form.enterReserveTime" :min="0" :precision="0" :step="5" controls-position="right"
            style="width: 160px"></el-input-number>
          <span class="unit">分钟</span>
          <div class="field-hint">目的地是场站、赶火车或飞机时加在行程时间上，不填按 60 分钟</div>
        </el-form-item>

        <el-form-item v-if="param.type === 3" label="出站预留：" prop="exitReserveTime">
          <el-input-number v-model="form.exitReserveTime" :min="0" :precision="0" :step="5" controls-position="right"
            style="width: 160px"></el-input-number>
          <span class="unit">分钟</span>
          <div class="field-hint">起点是场站、到站后再坐商务车时加在到站时间上，不填按 20 分钟</div>
        </el-form-item>

        <el-form-item label="关键字：" prop="keyName" v-if="param.type === 4 || param.type === 6">
          <el-input v-model="form.keyName" style="width: 100%"></el-input>
        </el-form-item>

        <el-form-item label="排序" prop="price">
          <el-input-number v-model="form.sortIndex" style="width: 100%"></el-input-number>
        </el-form-item>

        <el-form-item label="分组" prop="groupKey">
          <el-input v-model="form.groupKey" style="width: 100%"></el-input>
        </el-form-item>

        <el-form-item label="禁用" prop="disabled">
          <el-switch v-model="form.disabled" :active-value="true" :inactive-value="false"></el-switch>
        </el-form-item>

        <el-form-item label="接送范围" prop="pickOrSend">
          <el-select v-model="form.pickOrSend" placeholder="请选择" style="width: 100%">
            <el-option v-for="item in pickOrSendOpts" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="图片：" v-if="param.type === 5">
          <div>
            <multiple-file-upload v-model="form.imgUrls" :bucket="$ossBucket.PUBLIC"
              :filePath="$ossPath.marketingPoiImg()" :limit="4" simpleData />
            <div v-for="(file, index) in form.imgUrls" :key="index" class="file-item">
              <file-preview :value="file" />
            </div>
          </div>
        </el-form-item>

        <el-form-item label="视频：" v-if="param.type === 5">
          <div>
            <multiple-file-upload v-model="form.videoUrls" :bucket="$ossBucket.PUBLIC"
              :filePath="$ossPath.marketingPoiVideo()" simpleData />
            <div v-for="(file, index) in form.videoUrls" :key="index" class="file-item">
              <file-preview :value="file" />
            </div>
          </div>
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button type="warning" :size="size" @click="save">保存</el-button>
        <el-button type="info" :size="size" @click="visible = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  listArea,
  addRecommendAddress,
  modifyRecommendAddress,
  removeRecommendAddress,
  listRecommendAddress,
  listUpriceArea
} from "@/api";
import { mapState } from "vuex";
import { MapUtil } from "@/util";
import _ from "lodash";

const markY = require("../../../assets/image/mark_y.png");
/** 与同系列 mark_y 图标一致造型的灰色钉，用于「已禁用」 */
const markGrey = require("../../../assets/image/mark_grey.png");

/** 与加价区域页 AreaType 一致：城市范围 */
const CITY_SCOPE = 2;
/** 加价区域页城市范围的描边样式：黑边、透明填充，并置于标记下层 */
const CITY_SCOPE_STYLE = {
  strokeColor: "#000",
  fillColor: "transparent",
  bubble: true,
  zIndex: 1
};
export default {
  mounted() {
    this.initMap();
    this.queryArea();
    this.query();
  },
  computed: {
    /** 表格展示列表（可选按名称 / 状态排序） */
    sortedList() {
      const data = [...(this.list || [])];
      if (!this.sortProp || !this.sortOrder) return data;

      const orderFactor = this.sortOrder === "ascending" ? 1 : -1;

      data.sort((a, b) => {
        if (this.sortProp === "name") {
          const va = ((a.name != null ? a.name : "") + "").trim();
          const vb = ((b.name != null ? b.name : "") + "").trim();
          const cmp = va.localeCompare(vb, "zh-CN");
          return cmp * orderFactor;
        }

        if (this.sortProp === "disabled") {
          const va = this.isRowDisabled(a) ? 1 : 0;
          const vb = this.isRowDisabled(b) ? 1 : 0;
          return (va - vb) * orderFactor;
        }

        return 0;
      });

      return data;
    },

    ...mapState({
      size: (state) => state.btnSize,
      pathList: (state) => state.pathList,
      typeOpts: (state) => state.enumMap["RECOMMEND_ADDRESS_TYPE"],
      stationOpts: (state) => state.enumMap["STATION_TYPE"],
      pathOpts: (state) => {
        const pathList = state.pathList;
        return pathList.map((item) => {
          return {
            label: item.name,
            value: item.id
          };
        });
      }
    })
  },
  data() {
    return {
      visible: false,
      form: {},
      param: {
        areaId: 1,
        type: 1
      },
      enableAreaOpts: [],
      list: [],
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        keyName: [
          {
            validator: (rule, value, callback) => {
              if (this.param.type === 4 || this.param.type === 6) {
                if (!value || !String(value).trim()) {
                  callback(new Error("请输入关键字"));
                  return;
                }
              }
              callback();
            },
            trigger: "blur"
          }
        ]
      },
      selectMarkerIndex: -1,
      /** 当前聚焦的地址 id，城市范围晚到时保持该点的视野 */
      focusMarkerId: null,
      /** 与加价区域一致的城市范围多边形 */
      cityScopeOverlays: [],
      /** 已成功发起城市范围查询的区域，避免路线列表刷新时重复请求 */
      cityScopeAreaId: null,
      queryToken: 0,
      listReadyToken: 0,
      // 与 el-table sortable="custom" 配合
      sortProp: null,
      sortOrder: null,
      /** 与后端 RecommendAddress.pickOrSend 一致：0 接送都有效 1 仅接人 2 送人 */
      pickOrSendOpts: [
        { label: "接送都有效", value: 0 },
        { label: "仅接人有效", value: 1 },
        { label: "仅送人有效", value: 2 }
      ]
    };
  },
  watch: {
    pathList(list) {
      if (!list || !list.length || !this.queryToken) return;
      if (this.cityScopeAreaId === this.param.areaId) return;
      this.loadCityScope(this.queryToken);
    }
  },
  methods: {
    initMap() {
      this.map = new AMap.Map("up_price_map", {
        resizeEnable: true,
        dragEnable: true,
        zoom: 14
      });

      AMap.plugin(["AMap.PlaceSearch", "AMap.AutoComplete", "AMap.Scale"], () => {
        const scale = new AMap.Scale();
        this.map.addControl(scale);

        const autoOptions = {
          // input 为绑定输入提示功能的input的DOM ID
          input: "tipinput",
          city: "全国"
        };
        const autoComplete = new AMap.AutoComplete(autoOptions);
        autoComplete.on("select", this.select);
      });
    },

    rowClick(row) {
      this.syncTableHighlight(row.id);
      this.renderMarkers(row.id);
    },

    /** 自定义列排序回调 */
    handleSortChange({ prop, order }) {
      if ((prop !== "name" && prop !== "disabled") || !order) {
        this.sortProp = null;
        this.sortOrder = null;
        return;
      }
      this.sortProp = prop;
      this.sortOrder = order;
    },

    /** 根据记录 id 高亮表格行，并滚动到可视区域 */
    syncTableHighlight(rowId, options = {}) {
      const { scroll = true } = options;
      const idx = this.sortedList.findIndex((r) => r.id === rowId);
      this.selectMarkerIndex = idx >= 0 ? idx : -1;
      if (!scroll || idx < 0) return;
      this.$nextTick(() => {
        const table = this.$refs.dataTable;
        const wrap = table && table.bodyWrapper;
        if (!wrap) return;
        const rows = wrap.querySelectorAll(".el-table__body tbody tr");
        const rowEl = rows[idx];
        if (rowEl) rowEl.scrollIntoView({ block: "center", behavior: "smooth" });
      });
    },

    tableRowClassName({ rowIndex }) {
      if (rowIndex === this.selectMarkerIndex) {
        return "select-row";
      }
      return "";
    },

    queryArea() {
      // 只查询启用的区域
      listArea({}).then((res) => {
        const areas = res.data || [];
        this.enableAreaOpts = areas.map((item) => {
          return {
            label: item.name,
            value: item.id
          };
        });
      });
    },

    add() {
      if (this.info && this.info.poi) {
        const { address, location, name } = this.info.poi;
        const param = {
          areaId: this.param.areaId,
          type: this.param.type,
          name: address + name,
          longitude: location.lng,
          latitude: location.lat,
          disabled: false,
          pickOrSend: 0
        };
        addRecommendAddress(param).then(() => {
          this.query();
        });
      }
    },
    openDiag(record) {
      this.form = _.cloneDeep(record);
      if (this.form.disabled === undefined || this.form.disabled === null) {
        this.form.disabled = false;
      }
      if (this.form.pickOrSend === undefined || this.form.pickOrSend === null) {
        this.form.pickOrSend = 0;
      }
      if (this.param.type === 3) {
        ["enterReserveTime", "exitReserveTime"].forEach((key) => {
          const minutes = this.form[key];
          this.$set(this.form, key, this.emptyReserve(minutes) ? undefined : Number(minutes));
        });
      }
      this.visible = true;
    },

    formatReserve(minutes, fallback) {
      return this.emptyReserve(minutes) ? "默认" + fallback + "分钟" : minutes + "分钟";
    },

    emptyReserve(minutes) {
      return minutes === undefined || minutes === null || minutes === "";
    },

    isRowDisabled(row) {
      const d = row.disabled;
      return d === true || d === 1 || d === "1";
    },

    toggleDisabled(row) {
      const data = _.cloneDeep(row);
      data.disabled = !this.isRowDisabled(row);
      modifyRecommendAddress(data).then(() => {
        this.query();
      });
    },

    select(info) {
      this.info = info;
      this.addMarker(info.poi.location, info.poi.name);
    },
    addMarker(position, title) {
      if (this.marker) {
        this.map.remove(this.marker);
      }

      const marker = new AMap.Marker({
        position,
        title,
        icon: new AMap.Icon({
          image: markY
        }),
        anchor: "bottom-center",
        draggable: true,
        label: {
          //修改label相对于maker的位置
          direction: "top",
          content: "<div class='info active'>" + title + "</div>"
        }
      });

      this.marker = marker;
      this.map.add(marker);
      this.map.setFitView([marker]);
    },
    query() {
      const token = ++this.queryToken;
      this.focusMarkerId = null;
      this.cityScopeAreaId = null;
      this.cityScopeOverlays = [];
      this.loadCityScope(token);
      listRecommendAddress({ ...this.param }).then((res) => {
        if (token !== this.queryToken) return;
        this.list = res.data || [];
        this.listReadyToken = token;
        this.renderMarkers();
      });
    },

    /** 当前区域对应路线上的城市范围，样式与加价区域页一致 */
    loadCityScope(token) {
      const target = this.resolveCityScopeTarget();
      if (!target) return;
      this.cityScopeAreaId = this.param.areaId;
      this.fetchCityScope(target.primary)
        .then((list) => {
          if (token !== this.queryToken) return;
          const valid = this.validCityScopes(list);
          if (valid.length || !target.fallback) {
            this.applyCityScope(valid, token);
            return;
          }
          return this.fetchCityScope(target.fallback).then((fallbackList) => {
            if (token !== this.queryToken) return;
            this.applyCityScope(this.validCityScopes(fallbackList), token);
          });
        })
        .catch(() => { });
    },

    validCityScopes(list) {
      return (list || []).filter((item) => item.areaPoints && item.areaPoints.length);
    },

    resolveCityScopeTarget() {
      const areaId = Number(this.param.areaId);
      if (!areaId) return null;
      const all = this.pathList || [];
      const enabled = all.filter((item) => item.state !== false);
      const paths = enabled.length ? enabled : all;
      const starts = paths.filter((item) => Number(item.startArea) === areaId);
      const ends = paths.filter((item) => Number(item.endArea) === areaId);
      const startPath = starts.find((item) => item.isStartPath) || starts[0];
      const endPath = ends.find((item) => item.isStartPath) || ends[0];
      if (!startPath && !endPath) return null;
      const primary = startPath
        ? { pathId: startPath.id, isStart: true }
        : { pathId: endPath.id, isStart: false };
      const fallback =
        startPath && endPath && endPath.id !== startPath.id
          ? { pathId: endPath.id, isStart: false }
          : null;
      return { primary, fallback };
    },

    fetchCityScope(query) {
      return listUpriceArea({
        pathId: query.pathId,
        isStart: query.isStart,
        areaType: CITY_SCOPE,
        _hideLoading: true
      }).then((res) => res.data || []);
    },

    applyCityScope(list, token) {
      this.cityScopeOverlays = (list || []).map((item) =>
        MapUtil.json2Overlay(item, CITY_SCOPE_STYLE)
      );
      if (this.listReadyToken === token) {
        this.renderMarkers(this.focusMarkerId);
      }
    },

    syncPosition(index) {
      const row = this.sortedList[index];
      const marker =
        row &&
        this.markers.find((m) => {
          const d = m.getExtData();
          return d && d.id === row.id;
        });
      if (!marker) {
        return;
      }
      const data = marker.getExtData();
      const position = marker.getPosition();
      data.latitude = position.lat;
      data.longitude = position.lng;
      modifyRecommendAddress(data).then(() => {
        this.query();
      });
    },

    renderMarkers(id) {
      this.focusMarkerId = id || null;
      const markers = [];
      const map = this.map;
      if (!map) return;
      map.clearMap();

      let list = this.list || [];
      if (id) {
        list = list.filter((item) => item.id === id);
      }
      list.forEach((item) => {
        const position = [item.longitude, item.latitude];
        const marker = new AMap.Marker({
          position,
          icon: new AMap.Icon({
            image: this.isRowDisabled(item) ? markGrey : markY
          }),
          anchor: "bottom-center",
          label: {
            //修改label相对于maker的位置
            direction: "top",
            content: "<div class='info '>" + item.name + "</div>"
          },
          draggable: true,
          extData: item
        });
        marker.on("click", () => {
          this.syncTableHighlight(item.id);
        });
        markers.push(marker);
      });

      this.markers = markers;
      if (markers.length) {
        map.add(markers);
      }
      if (this.cityScopeOverlays.length) {
        map.add(this.cityScopeOverlays);
      }
      if (id && markers.length) {
        map.setFitView(markers);
      } else if (this.cityScopeOverlays.length) {
        map.setFitView(this.cityScopeOverlays.concat(markers));
      } else if (markers.length) {
        map.setFitView(markers);
      }
    },
    del(record) {
      this.$confirm("确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        removeRecommendAddress(record).then(() => {
          this.query();
        });
      });
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        const payload = { ...this.form };
        if (this.param.type === 3) {
          ["enterReserveTime", "exitReserveTime"].forEach((key) => {
            payload[key] = this.emptyReserve(payload[key]) ? null : Number(payload[key]);
          });
        }
        modifyRecommendAddress(payload).then(() => {
          this.visible = false;
          this.query();
        });
      });
    }
  }
};
</script>

<style scoped lang="less">
#up_price_map {
  height: 100%;
  width: 60%;
}

.up_price_map {
  width: 100%;
  height: 750px;
  position: relative;
  overflow: hidden;
  display: flex;

  .box {
    flex: 1;
    margin-left: 10px;
  }
}

#tipinput {
  height: 30px;
  line-height: 30px;
  padding-left: 10px;
  border: none;
  outline: none;
}

.query-container {
  height: 40px;
  padding: 10px 20px;
}

.unit {
  margin-left: 8px;
}

.field-hint {
  color: #909399;
  font-size: 12px;
  line-height: 1.4;
}

/deep/ .el-table .select-row {
  background: #f0f9eb !important;

  td {
    background: #f0f9eb !important;
  }
}
</style>
